<template>
  <div class="container machine-edit-container">
    <div class="card">
      <div class="card-header">
        <div class="row">
          <div class="card-header-label col-6">
            <span>Editar máquina</span>
          </div>
          <div class="card-header-action-buttons col-6">
            <ButtonComponent :buttonText="'Refrescar'" :buttonColor="colors.BLUE_COLOR_BUTTON"
              :buttonAction="refreshData" />
          </div>
        </div>
      </div>

      <SpeenComponent v-if="isLoading" style="padding: 5ch 0;" :isAutomatic="true" :ringWidth="14" :spinnerSize="15"
        :isverticalAligned="true" />

      <div class="card-body" v-else>
        <form @submit.prevent="updateMachine">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="code">Código</label>
                <input type="text" id="code" v-model="machine.code" class="form-control" />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="machine_type_id">Tipo de máquina</label>
                <select id="machine_type_id" v-model="machine.machine_type_id" class="form-control">
                  <option disabled value="">Seleccione un tipo</option>
                  <option v-for="machineType in machineTypes" :key="machineType.id" :value="machineType.id">
                    {{ machineType.descrip }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="form-group mt-2">
                <label for="descrip">Descripción</label>
                <input type="text" id="descrip" v-model="machine.descrip" class="form-control" />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group mt-2">
                <label for="mqtt_machine_id">MQTT Machine ID</label>
                <input type="text" id="mqtt_machine_id" v-model="machine.mqtt_machine_id" class="form-control" />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <div class="form-group mt-2">
                <label for="target_oee">OEE Objetivo</label>
                <input type="number" id="target_oee" v-model="machine.target_oee" class="form-control" />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group mt-2">
                <label for="efficiency_pct">Porcentaje de eficiencia</label>
                <input type="number" id="efficiency_pct" v-model="machine.efficiency_pct" class="form-control" />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group form-switch" style="margin-top: 2rem;">
                <input type="checkbox" id="has_data_display" v-model="machine.has_data_display"
                  class="form-check-input" />
                <label for="has_data_display">Mostrar datos</label>
              </div>
            </div>
          </div>

          <hr />
          <div class="d-flex justify-content-end">
            <ButtonComponent :buttonText="'Guardar'" :buttonColor="colors.GREEN_COLOR_BUTTON" :button-action="updateMachine" />
          </div>
        </form>

        <hr />

        <div class="machine-topic-header">
          <div class="row">
            <div class="machine-topic-header-label col-2">
              <span>Tópicos</span>
            </div>
            <div class="machine-topic-header-pagination col-8">
              <b-pagination v-model="currentPage" :total-rows="machineTopics.length" :per-page="perPage"
                aria-controls="machine-topics-table" style="margin: 0" align="center" />
            </div>
            <div class="machine-topic-header-action-buttons col-2">
              <ButtonComponent :buttonText="'Nuevo'" :buttonColor="colors.GREEN_COLOR_BUTTON"
                :buttonAction="openCreateMachineTopicModal" :disabled="topicTypesOptions.length === 0" />
            </div>
          </div>
        </div>

        <hr />

        <b-table id="machine-topics-table" striped hover :items="machineTopics" :fields="fields" responsive
          :per-page="perPage" :current-page="currentPage">
          <template v-slot:cell(actions)="data">
            <ButtonComponent :buttonText="'Editar'" :buttonColor="colors.GREEN_COLOR_BUTTON"
              :buttonAction="() => openEditMachineTopicModal(data.item)" />
            <ButtonComponent :buttonText="'Borrar'" :buttonColor="colors.RED_COLOR_BUTTON"
              :buttonAction="() => confirmDeleteMachineTopic(data.item)" />
          </template>
        </b-table>
      </div>
    </div>
    <transition name="slide-fade">
      <MachineTopicModal v-if="showMachineTopicModal" :isCreating="isCreating" :formData="topicFormData"
        :topicTypes="topicTypesOptions" @form-submitted="refreshData" @close-modal="closeTopicModal" />
      <ActionConfirmModal v-if="showActionConfirmModal" :contentMessage="actionConfirmModalMessage"
        :closeModal="closeActionConfirmModal" :methodForProp="methodForProp" />
    </transition>

  </div>
</template>

<script>
import SpeenComponent from '../../common/components/SpeenComponent.vue';
import { showCustomErrorSweetAlert, showCustomSuccessSweetAlert } from '../../common/utils';
import ButtonComponent from '../../common/components/ButtonComponent.vue';
import Colors from '../../common/colors';
import MachineTopicModal from '../components/MachineTopicModal.vue';
import ActionConfirmModal from '../../common/components/modals/ActionConfirmModal.vue';

export default {
  name: 'MachineEdit',
  components: {
    SpeenComponent,
    ButtonComponent,
    MachineTopicModal,
    ActionConfirmModal,
  },
  props: {
    machineIdProp: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      isLoading: false,
      colors: Colors,
      perPage: 5,
      currentPage: 1,
      machine: [],
      topicEditFormData: {
        topic_type: '',
        topic_name: '',
        id: -1,
      },
      topicCreateFormData: {
        machine_id: this.machineIdProp,
        topic_type: '',
        topic_name: '',
      },
      topicFormData: {},
      machineTypes: [],
      machineTopics: [],
      showMachineTopicModal: false,
      isCreating: false,
      showActionConfirmModal: false,
      actionConfirmModalMessage: '',
      methodForProp: null,
      topicTypes: ["unit_count", "control_weight", "gross_weight"],
      topicTypesOptions: [],
      fields: [
        { key: 'topic_type', label: 'Tipo de tópico', sortable: true },
        { key: 'actions', label: 'Acciones' }
      ],

    };
  },
  methods: {
    getMachineData() {
      this.isLoading = true;
      axios.get(`/api/machine/get-data/${this.machineIdProp}`)
        .then(response => {
          this.machine = response.data;
        })
        .catch(error => {
          showCustomErrorSweetAlert(error.response.data);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    getMachineTypes() {
      axios.get('/api/machine/get-machine-types')
        .then(response => {
          this.machineTypes = response.data;
        })
        .catch(error => {
          showCustomErrorSweetAlert(error.response.data);
        })
    },
    getMachineTopics() {
      axios.get(`/api/machine/${this.machineIdProp}/get-machine-topics`)
        .then(response => {
          this.machineTopics = response.data;
        })
        .catch(error => {
          showCustomErrorSweetAlert(error.response.data);
        })
        .finally(() => {
          this.prepareMachineTopicTypes();
        });
    },
    updateMachine() {
      this.isLoading = true;
      if (typeof this.machine.efficiency_pct === 'string' || typeof this.machine.efficiency_pct === 'number') {
        let num = Number(this.machine.efficiency_pct);
        if (!isNaN(num)) {
          this.machine.efficiency_pct = num.toFixed(2);
        }
      }
      axios.patch(`/api/machine/admon/${this.machineIdProp}`, this.machine)
        .then(response => {
          this.machine.efficiency_pct = Number(response.data.efficiency_pct);
          showCustomSuccessSweetAlert('Máquina editada correctamente');
          this.getMachineData();
        })
        .catch(error => {
          showCustomErrorSweetAlert(error.response.data);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    confirmDeleteMachineTopic(machineTopic) {
      this.actionConfirmModalMessage = `¿Está seguro de que desea eliminar el tópico ${machineTopic.topic_type}?`;
      this.methodForProp = () => {
        this.deleteMachineTopic(machineTopic.id);
      };
      this.openActionConfirmModal();
    },
    deleteMachineTopic(machineTopicId) {
      axios.delete(`/api/machine-topic/${machineTopicId}/delete-machine-topic`)
        .then(response => {
          showCustomSuccessSweetAlert('Tópico eliminado correctamente');
          this.getMachineTopics();
        })
        .catch(error => {
          showCustomErrorSweetAlert(error.response.data);
        })
        .finally(() => {
          this.closeActionConfirmModal();
        });
    },
    prepareMachineTopicTypes() {
      let topicsSelected = this.machineTopics.map(topic => topic.topic_type);
      this.topicTypesOptions = this.topicTypes.filter(topic => !topicsSelected.includes(topic));
    },
    openEditMachineTopicModal(machineTopic) {
      this.isCreating = false;
      this.topicEditFormData = {
        topic_type: machineTopic.topic_type,
        topic_name: machineTopic.topic_name,
        topic_id: machineTopic.id,
      };
      this.topicFormData = this.topicEditFormData;
      this.topicTypesOptions.push(machineTopic.topic_type);
      this.showMachineTopicModal = true;
    },
    openCreateMachineTopicModal() {
      this.isCreating = true;
      this.topicCreateFormData = {
        machine_id: this.machineIdProp,
        topic_type: '',
        topic_name: ''
      };
      this.topicFormData = this.topicCreateFormData;
      this.prepareMachineTopicTypes();
      this.showMachineTopicModal = true;
    },
    closeTopicModal() {
      this.showMachineTopicModal = false;
    },
    refreshData() {
      this.getMachineTypes();
      this.getMachineTopics();
      this.getMachineData();
    },
    openActionConfirmModal() {
      this.showActionConfirmModal = true;
    },
    closeActionConfirmModal() {
      this.showActionConfirmModal = false;
    },
  },
  mounted() {
    this.refreshData();
  }
};
</script>
